import { render } from "./EncontroAdminsPage.vue?vue&type=template&id=6bba2465&scoped=true"
import script from "./EncontroAdminsPage.vue?vue&type=script&lang=js"
export * from "./EncontroAdminsPage.vue?vue&type=script&lang=js"

import "./EncontroAdminsPage.vue?vue&type=style&index=0&id=6bba2465&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bba2465"]])

export default __exports__